export const LARGE = 0x00;
export const DESKTOP = 0x01;
export const TABLET = 0x02;
export const MOBILE = 0x03;
